@file:OptIn(ExperimentalTime::class)

package com.macrofocus.trenddisplay.timeseriesplot

import com.macrofocus.common.format.FormatFactory
import com.macrofocus.license.LicenseModel
import com.macrofocus.plot.guide.DateAxis
import com.macrofocus.plot.guide.NumberAxis
import org.mkui.canvas.CPCanvas
import org.mkui.component.CPFactory
import org.mkui.component.CPInteractiveComponent
import org.mkui.font.CPFontFactory
import org.mkui.graphics.CPHeadless
import org.mkui.palette.PaletteFactory
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

class DefaultTimeSeriesPlotView<Row,Column> : AbstractTimeSeriesPlotView<Row, Column>(CPCanvas(), CPFactory.instance, PaletteFactory.instance) {
    override val component : CPInteractiveComponent
        get() = canvas

    override val width: Int
        get() = canvas.getWidth().toInt()
    override val height: Int
        get() = canvas.getHeight().toInt()

    override fun refresh() {
        canvas.refresh()
    }

    override fun repaint() {
        canvas.redraw()
    }

    override fun scheduleUpdate() {
        canvas.refresh()
    }

    override fun updateAxisType() {
        if (model?.time?.isActive == true) {
            if (model?.time?.selected?.type == Instant::class) {
                xGuide.setAxis(
                    DateAxis(
                        CPFontFactory.instance,
                        CPHeadless,
                        FormatFactory.instance
                    )
                )
            } else {
                xGuide.setAxis(
                    NumberAxis(
                        CPFontFactory.instance,
                        CPHeadless,
                        FormatFactory.instance
                    )
                )
            }
        }
        if (model?.y?.isActive == true) {
            if (model?.y?.selected?.type === Instant::class) {
                yGuide.setAxis(
                    DateAxis(
                        CPFontFactory.instance,
                        CPHeadless,
                        FormatFactory.instance
                    )
                )
            } else {
                yGuide.setAxis(
                    NumberAxis(
                        CPFontFactory.instance,
                        CPHeadless,
                        FormatFactory.instance
                    )
                )
            }
        }
    }
    override var isShowTiming: Boolean
        get() = canvas.showTiming.value
        set(value) { canvas.showTiming.value = value }

    override fun setLicenseModel(licenseModel: LicenseModel?) {
//        TODO("Not yet implemented")
    }

    override var isMaintainAspectRatio: Boolean
        get() = false
        set(value) {}
}